import React from "react";
import { t } from "i18next";

function IconesDivers() {
    return (
        <div
            className="not-allowed-icon__clz mt-3 mx-2"
            style={{
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <h5 style={{ fontWeight: "bold" }}>{t("Icons")}</h5>

            <div
                style={{
                    display: "flex",
                    width: "93%",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    marginTop: "10px",
                    flexWrap: "wrap",
                }}
            >
                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        {t("Basket")}
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Basket")}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        {t("Empty basket")}
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Empty basket")}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        {t("My account")}
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("My account")}
                    </span>
                </div>

                <div
                    style={{
                        width: "20%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "10px",
                            border: "1px solid #a19e9e",
                            background: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                            fontSize: "12px",
                        }}
                    >
                        {t("Product information")}
                    </div>
                    <span
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                        }}
                    >
                        {t("Product information")}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default IconesDivers;
